import React, { ReactNode } from 'react';

import {
  Slant as SlantV5,
  SlantProps as SlantV5Props,
} from '@sbu/components.slant';

interface SlantProps extends SlantV5Props {
  children?: ReactNode;
}

export const Slant = ({ children, ...props }: SlantProps) => {
  return <SlantV5 {...props}>{children}</SlantV5>;
};
